import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Checkbox, Input, InputNumber, Modal, Select, Divider, message } from "antd";
import { getMineralAnalysisPrices } from "../../modules/actions/mineralActions";
import { mineralSampleTypes, mineralAnalysisTypes, MineralAnalysisPrice } from "../constant/constant";

const { Option } = Select;
const { TextArea } = Input;

function AddMineralModal(props) {
    const [modalVisible, setModalVisible] = useState(false);
    const [sampleType, setSampleType] = useState("Mineral");
    const [sampleTypeOther, setSampleTypeOther] = useState("");
    const [quantityWeight, setQuantityWeight] = useState("");
    const [descriptionMarks, setDescriptionMarks] = useState("");
    const [requestedAnalysis, setRequestedAnalysis] = useState([]);
    const [otherAnalysis, setOtherAnalysis] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);

    const isEditMode = !!props.editData;

    useEffect(() => {
        props.getMineralAnalysisPrices();
    }, []);

    useEffect(() => {
        if (props.visible) {
            setModalVisible(true);
        }
    }, [props.visible]);

    // Pre-fill when editData is provided
    useEffect(() => {
        if (props.editData) {
            const d = props.editData;
            setSampleType(d.sampleType || "Mineral");
            setSampleTypeOther(d.sampleTypeOther || "");
            setQuantityWeight(d.quantityWeight || "");
            setDescriptionMarks(d.descriptionMarks || "");
            setRequestedAnalysis(d.requestedAnalysis || []);
            setOtherAnalysis(d.otherAnalysis || "");
            setTotalAmount(d.totalAmount || 0);
        }
    }, [props.editData]);

    const calculateTotalAmount = (selectedAnalyses) => {
        let amount = 0;
        const prices = props.mineralAnalysisPrices || MineralAnalysisPrice;
        selectedAnalyses.forEach(analysis => {
            const priceObj = prices.find(p =>
                (p.analysisType === analysis) || (p.name === analysis)
            );
            if (priceObj) {
                if (props.membershipActive) {
                    amount += Number(priceObj.memberPrice || priceObj.member_price || 0);
                } else {
                    amount += Number(priceObj.price || 0);
                }
            }
        });
        setTotalAmount(amount);
    };

    const handleAnalysisChange = (checkedValues) => {
        setRequestedAnalysis(checkedValues);
        calculateTotalAmount(checkedValues);
    };

    const clearState = () => {
        setSampleType("Mineral");
        setSampleTypeOther("");
        setQuantityWeight("");
        setDescriptionMarks("");
        setRequestedAnalysis([]);
        setOtherAnalysis("");
        setTotalAmount(0);
    };

    const setModalVisibleFn = (visible) => {
        setModalVisible(visible);
        if (!visible) {
            clearState();
            props.onClose();
        }
    };

    const handleSubmit = () => {
        if (!quantityWeight) {
            message.error("Please enter quantity/weight");
            return;
        }
        if (requestedAnalysis.length === 0) {
            message.error("Please select at least one analysis type");
            return;
        }

        props.onAddMineral({
            sampleType: sampleType,
            sampleTypeOther: sampleType === "Other" ? sampleTypeOther : "",
            quantityWeight: quantityWeight,
            descriptionMarks: descriptionMarks,
            requestedAnalysis: requestedAnalysis,
            otherAnalysis: otherAnalysis,
            totalAmount: totalAmount,
        });

        clearState();
        setModalVisible(false);
        props.onClose();
    };

    const buildUpdatePayload = () => ({
        sampleType,
        sampleTypeOther: sampleType === "Other" ? sampleTypeOther : "",
        quantityWeight,
        descriptionMarks,
        requestedAnalysis,
        otherAnalysis,
        totalAmount,
    });

    const handleUpdate = () => {
        if (!quantityWeight) { message.error("Please enter quantity/weight"); return; }
        if (requestedAnalysis.length === 0) { message.error("Please select at least one analysis type"); return; }
        if (props.onUpdate) props.onUpdate(props.editData.entryNo, buildUpdatePayload());
    };

    const handleUpdateAndContinue = () => {
        if (!quantityWeight) { message.error("Please enter quantity/weight"); return; }
        if (requestedAnalysis.length === 0) { message.error("Please select at least one analysis type"); return; }
        if (props.onUpdateAndContinue) props.onUpdateAndContinue(props.editData.entryNo, buildUpdatePayload());
    };

    return (
        <Modal
            title={isEditMode ? "Edit Mineral Sample" : "Add Mineral Sample"}
            centered
            visible={modalVisible}
            onCancel={() => setModalVisibleFn(false)}
            width={800}
            className="AddModal"
            footer={[
                <button
                    key="cancel"
                    type="button"
                    className="ant-btn"
                    style={{ background: "#f50057", color: "white", borderColor: "#f50057" }}
                    onClick={() => setModalVisibleFn(false)}
                >
                    <span>Cancel</span>
                </button>,
                isEditMode ? (
                    <button
                        key="update-continue"
                        type="button"
                        className="ant-btn ant-btn-primary"
                        style={{ background: "#001529", color: "white", borderColor: "#001529" }}
                        onClick={handleUpdateAndContinue}
                    >
                        <span>Update &amp; Continue</span>
                    </button>
                ) : null,
                isEditMode ? (
                    <button
                        key="update"
                        type="button"
                        className="ant-btn ant-btn-primary"
                        style={{ background: "#001529", color: "white", borderColor: "#001529" }}
                        onClick={handleUpdate}
                    >
                        <span>Update</span>
                    </button>
                ) : (
                    <button
                        key="add"
                        type="button"
                        className="ant-btn ant-btn-primary"
                        style={{ background: "#001529", color: "white", borderColor: "#001529" }}
                        onClick={handleSubmit}
                    >
                        <span>Add Mineral</span>
                    </button>
                ),
            ]}
        >
            <div className="addItemForm">
                <Divider className="w100P" orientation="left">Sample Details</Divider>

                <div className="inputFields">
                    <label>
                        <h5>Sample Type</h5>
                        <Select
                            value={sampleType}
                            onChange={(val) => setSampleType(val)}
                            className="select"
                        >
                            {mineralSampleTypes.map(type => (
                                <Option key={type} value={type}>{type}</Option>
                            ))}
                        </Select>
                    </label>
                </div>

                {sampleType === "Other" && (
                    <div className="inputFields">
                        <label>
                            <h5>Specify Other</h5>
                            <Input
                                value={sampleTypeOther}
                                onChange={(e) => setSampleTypeOther(e.target.value)}
                                placeholder="Enter sample type"
                            />
                        </label>
                    </div>
                )}

                <div className="inputFields">
                    <label>
                        <h5>Quantity / Weight</h5>
                        <Input
                            value={quantityWeight}
                            onChange={(e) => setQuantityWeight(e.target.value)}
                            placeholder="e.g., 500g, 2kg"
                        />
                    </label>
                </div>

                <div className="inputFields w100P">
                    <label>
                        <h5>Description / Identification Marks</h5>
                        <TextArea
                            value={descriptionMarks}
                            onChange={(e) => setDescriptionMarks(e.target.value)}
                            placeholder="Enter description or identification marks"
                            rows={3}
                        />
                    </label>
                </div>

                <Divider className="w100P" orientation="left">Requested Analysis</Divider>

                <div className="inputFields w100P">
                    <Checkbox.Group
                        value={requestedAnalysis}
                        onChange={handleAnalysisChange}
                        style={{ width: "100%" }}
                    >
                        <div className="checkboxGroup" style={{ flexWrap: "wrap", gap: "8px" }}>
                            {mineralAnalysisTypes.map(type => (
                                <Checkbox key={type} value={type}>
                                    {type}
                                </Checkbox>
                            ))}
                        </div>
                    </Checkbox.Group>
                </div>

                <div className="inputFields">
                    <label>
                        <h5>Other Analysis</h5>
                        <Input
                            value={otherAnalysis}
                            onChange={(e) => setOtherAnalysis(e.target.value)}
                            placeholder="Enter other analysis type"
                        />
                    </label>
                </div>

                <div className="inputFields">
                    <label>
                        <h5>Calculated Amount</h5>
                        <InputNumber
                            value={totalAmount}
                            disabled
                            className="w100P"
                        />
                    </label>
                </div>
            </div>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    const mineralStore = state.mineralStore || {};
    return {
        mineralAnalysisPrices: mineralStore.mineralAnalysisPrices,
        membershipActive: state.authentication.membershipActive,
    };
};

const mapDispatchToProps = (dispatch) => ({
    getMineralAnalysisPrices: () => dispatch(getMineralAnalysisPrices()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMineralModal);